import React, { ReactNode } from "react";

interface PublicLayoutProps {
  leftContent?: ReactNode;
  rightContent?: ReactNode;
  children?: ReactNode; // Αν θες να υποστηρίζει και απλό children
}

const PublicLayout: React.FC<PublicLayoutProps> = ({
  leftContent,
  rightContent,
  children,
}) => {
  return (
    <div className="w-full min-h-screen bg-lightprimary p-8 box-border">
      <header className="mb-6">
        <h1 className="text-2xl font-bold text-gray-800">
          Σύστημα Κράτησης Ραντεβού
        </h1>
      </header>

      {/* Δομή δύο στηλών: Αριστερά η φόρμα, δεξιά το ημερολόγιο */}
      <main className="flex gap-6 items-start w-full">
        {leftContent && <div className="w-[380px] shrink-0">{leftContent}</div>}

        {rightContent && <div className="flex-1 min-w-0">{rightContent}</div>}

        {children}
      </main>
    </div>
  );
};

export default PublicLayout;
